import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import EmptyStateSvg from 'images/v5/empty-states/default.png';
import Caption from 'layout/atoms/Caption';
import Label from 'layout/atoms/Label';
import styles from './EmptyState.module.scss';
function EmptyState({ size = 'l', icon, noIcon = false, header, subheader, noHeader = false, noSubheader = false, children, }) {
    const { t } = useTranslation(['common']);
    const classes = classNames(styles.wrap, styles[size]);
    return (React.createElement("div", { className: classes },
        !noIcon && React.createElement("div", { className: styles.icon }, icon || React.createElement("img", { src: EmptyStateSvg, alt: "" })),
        React.createElement("div", { className: styles.text },
            !noHeader && (React.createElement(Label, { size: "s", color: "normal" }, header || t('no_results_header'))),
            !noSubheader && React.createElement(Caption, null, subheader || t('no_results_subheader'))),
        React.createElement("div", { className: styles.button }, children && children)));
}
export default EmptyState;
